module.exports = __webpack_public_path__ + "static/devices-e5ece3a984517f2df43c4912d771aceb.png";